<script>
export default {
  name: 'BottomSheet',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
};
</script>

<template>
  <teleport to="body">
    <div v-if="show" class="bottom-sheet-overlay" @click.self="$emit('close')">
      <div class="bottom-sheet-container">
        <div v-if="$slots.header">
          <slot name="header" />
        </div>
        <button
          v-else-if="showClose"
          class="bottom-sheet-close-button"
          @click="$emit('close')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M4.929 4.929a1.5 1.5 0 0 0 0 2.121L9.879 12l-4.95 4.95A1.5 1.5 0 0 0 7.05 19.07l4.95-4.95 4.95 4.95a1.5 1.5 0 0 0 2.121-2.121L14.121 12l4.95-4.95A1.5 1.5 0 1 0 16.95 4.93L12 9.879l-4.95-4.95a1.5 1.5 0 0 0-2.121 0"
            />
          </svg>
        </button>
        <slot />
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.bottom-sheet-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
}

.bottom-sheet-container {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  width: 100vw;
  min-width: 0;
  padding: 1.25rem;
  margin: 0;
  z-index: 9999;
}

.bottom-sheet-close-button {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #a3a3a3;
}
</style>
